import {
    GET_DASHBOARD_DATA_REQUEST,
    GET_DASHBOARD_DATA_SUCCESS,
    GET_DASHBOARD_DATA_FAILURE,
    ADD_BOOKING_REQUEST,
    ADD_BOOKING_SUCCESS,
    ADD_BOOKING_FAILURE,
    GET_CASE_DETAILS_REQUEST,
    GET_CASE_DETAILS_SUCCESS,
    GET_CASE_DETAILS_FAILURE,
    ADD_DENTIST_REQUEST,
    ADD_DENTIST_FAILURE,
    ADD_DENTIST_SUCCESS,
    ADD_PATIENT_DASHBOARD_REQUEST,
    ADD_PATIENT_DASHBOARD_SUCCESS,
    ADD_PATIENT_DASHBOARD_FAILURE,
    GET_PARENT_CASES_REQUEST,
    GET_PARENT_CASES_FAILURE,
    GET_PARENT_CASES_SUCCESS,
    UPDATE_TABLE_CONFIG,
    UPDATE_TABLE_CONFIG_FAILURE,
    UPDATE_TABLE_CONFIG_SUCCESS,
    GET_ALL_PATIENTS_REQUEST,
    GET_ALL_PATIENTS_SUCCESS,
    GET_ALL_PATIENTS_FAILURE,
    GET_SMALL_CALENDAR_DATA_REQUEST,
    GET_SMALL_CALENDAR_DATA_SUCCESS,
    GET_SMALL_CALENDAR_DATA_FAILURE,
    ADD_VACATION_DAYS_REQUEST,
    ADD_VACATION_DAYS_SUCCESS,
    ADD_VACATION_DAYS_FAILURE,
    GET_VACATION_DAYS_REQUEST,
    GET_VACATION_DAYS_SUCCESS,
    GET_VACATION_DAYS_FAILURE,
    DELETE_VACATION_DAYS_REQUEST,
    DELETE_VACATION_DAYS_SUCCESS,
    DELETE_VACATION_DAYS_FAILURE,
    RESET_VACATIONS_SUCCESS, RESET_VACATIONS_DELETE,
} from './constants';

export function getData(startOfCalendarView, endOfCalendarView) {
    return {
        type: GET_DASHBOARD_DATA_REQUEST,
        data: {startOfCalendarView, endOfCalendarView}
    }
}

export function getDataSuccess(response) {
    return {
        type: GET_DASHBOARD_DATA_SUCCESS,
        data: response
    }
}

export function getDataFailure() {
    return {
        type: GET_DASHBOARD_DATA_FAILURE,
        data: {}
    }
}

export function getSmallCalendarDataFailure() {
    return {
        type: GET_SMALL_CALENDAR_DATA_FAILURE,
        data: {}
    }
}

export function getSmallCalendarData(startOfCalendarView, endOfCalendarView) {
    return {
        type: GET_SMALL_CALENDAR_DATA_REQUEST,
        data: {startOfCalendarView, endOfCalendarView}
    }
}

export function getDataSmallCalendarSuccess(response) {
    return {
        type: GET_SMALL_CALENDAR_DATA_SUCCESS,
        data: response
    }
}

export function addBooking(data) {
    return {
        type: ADD_BOOKING_REQUEST,
        data: data
    }
}

export function addBookingSuccess(response) {
    return {
        type: ADD_BOOKING_SUCCESS,
        data: response
    }
}

export function addBookingFailure(error) {
    return {
        type: ADD_BOOKING_FAILURE,
        data: error
    }
}

export function getCase(caseId) {
    return {
        type: GET_CASE_DETAILS_REQUEST,
        caseId: caseId
    }
}

export function getCaseSuccess(response) {
    return {
        type: GET_CASE_DETAILS_SUCCESS,
        data: response
    }
}

export function getCaseFailure() {
    return {
        type: GET_CASE_DETAILS_FAILURE,
        data: {}
    }
}

export function addDentist(data) {
    return {
        type: ADD_DENTIST_REQUEST,
        data
    }
}

export function addDentistSuccessAction(data) {
    return {
        type: ADD_DENTIST_SUCCESS,
        data
    }
}

export function addDentistFailureAction(data) {
    return {
        type: ADD_DENTIST_FAILURE,
        data
    }
}

export function addPatient(data) {
    return {
        type: ADD_PATIENT_DASHBOARD_REQUEST,
        data
    }
}

export function addPatientSuccess(response) {
    return {
        type: ADD_PATIENT_DASHBOARD_SUCCESS,
        data: response
    }
}

export function addPatientFailure() {
    return {
        type: ADD_PATIENT_DASHBOARD_FAILURE,
        data: {}
    }
}

export function getParentCases() {
    return {
        type: GET_PARENT_CASES_REQUEST
    }
}

export function getParentCasesSuccess(response) {
    return {
        type: GET_PARENT_CASES_SUCCESS,
        data: response
    }
}

export function getParentCasesFailure() {
    return {
        type: GET_PARENT_CASES_FAILURE,
        data: {}
    }
}

export function setFilterValues(data) {
    return {
        type: UPDATE_TABLE_CONFIG,
        data
    }
}

export function setFilterValuesFailure() {
    return {
        type: UPDATE_TABLE_CONFIG_FAILURE,
        data: {}
    }
}

export function setFilterValuesSuccess(response) {
    return {
        type: UPDATE_TABLE_CONFIG_SUCCESS,
        data: response
    }
}

export function getAllPatientsRequest(data) {
    return {
        type: GET_ALL_PATIENTS_REQUEST,
        data
    }
}

export function getAllPatientsSuccess(response) {
    return {
        type: GET_ALL_PATIENTS_SUCCESS,
        data: response
    }
}

export function getAllPatientsFailure() {
    return {
        type: GET_ALL_PATIENTS_FAILURE,
        data: {}
    }
}

export function addVacationDaysRequest(data) {
    return {
        type: ADD_VACATION_DAYS_REQUEST,
        data: data
    }
}

export function addVacationDaysSuccess(response) {
    return {
        type: ADD_VACATION_DAYS_SUCCESS,
        data: response
    }
}

export function addVacationDaysFailure(error) {
    return {
        type: ADD_VACATION_DAYS_FAILURE,
        data: error
    }
}

export function getVacationDaysRequest(startOfCalendarView) {
    return {
        type: GET_VACATION_DAYS_REQUEST,
        data:startOfCalendarView
    }
}

export function getVacationDaysSuccess(response) {
    return {
        type: GET_VACATION_DAYS_SUCCESS,
        data: response
    }
}

export function getVacationDaysFailure() {
    return {
        type: GET_VACATION_DAYS_FAILURE,
        data: {}
    }
}

export function deleteVacationDaySuccess(response) {
    return {
        type: DELETE_VACATION_DAYS_SUCCESS,
        data: response
    }
}

export function deleteVacationDayFailure() {
    return {
        type: DELETE_VACATION_DAYS_FAILURE,
        data: {}
    }
}

export function deleteVacationDayRequest(data) {
    return {
        type: DELETE_VACATION_DAYS_REQUEST,
        data: data
    }
}

export function resetVacationsSuccess(data) {
    return {
        type: RESET_VACATIONS_SUCCESS,
        data: data
    }
}

export function resetVacationsDelete(data) {
    return {
        type: RESET_VACATIONS_DELETE,
        data: data
    }
}


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/dashboard/actions.js